module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/chitfund/chit-claim/chit-claim.component.css
// module id = ./src/app/chitfund/chit-claim/chit-claim.component.css
// module chunks = main